import useLocalize from '../../../utils/hooks/useLocalize';
import SectionHeaderComponent from '../SectionHeaderComponent';
import './SummarySection.scss';

const MatrixSection = () => {
  const localize = useLocalize();
  const title = localize('symbol.details.matrix.section.title');
  return (
    <div className="summary-section">
      <SectionHeaderComponent title={title} />
      <div className="summary-section-content">
        {/* Matrix content will be added in future stories */}
      </div>
    </div>
  );
};

export default MatrixSection;
